import {site_url} from '../../../utils/urls';
import '../../layout';

function upload_files(form, selection) {
    const csrf = document.body.getAttribute('data-csrf');
    const headers = { 
        "Accept": "application/json", 
        "X-CSRF-Token": csrf   
    };

    if (!selection) {
        selection = form.querySelectorAll('input[type=file]');
    }

    const all_uploads = [];

    for (const file of selection) {
        const file_id = form[file.name + '_id'];
        const data = file.files[0];
        let url;

        if (file_id.value) {
            url = site_url(file_id.value);
        } else {
            url = form.getAttribute('data-profile-picture');
        }

        if (data) {
            const body = new FormData();

            body.set('content', data, data.name);
            body.set('title', 'Expert picture');
            body.set('on_success', '303');

            const upload = fetch(url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: headers,
                body: body
            }).then(
                response => response.ok ? response.json() : Promise.reject(response)
            ).then(json => {
                file_id.value=json.id;
                return file_id;
            }).catch(
                () => console.log('ERROR FILE UPLOAD')
            );

            all_uploads.push(upload);
        }
    }

    return all_uploads;
}


document.addEventListener('DOMContentLoaded', (e) => {
    const expert_form = document.getElementById('copbh_expert_form');

    expert_form.addEventListener('submit', (e) => {
        e.preventDefault();
        const selection = expert_form.querySelectorAll('input[type=file]');
        Promise.all(upload_files(expert_form, selection)).then(() => {
            for (const s of selection) {
                s.parentNode.removeChild(s);
            }
            expert_form.submit();
        });
    });

});
